export default __webpack_public_path__ + "static/media/scholar_2.d6ecaddc.jpg";